module.exports = __webpack_public_path__ + "static/img/4.424ba04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/4.png
// module id = TWyp
// module chunks = 1